import Icon from '../components/Icon.vue'

Icon.register({
  'square-full': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M512 512h-512v-512h512v512z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/square-full.js
// module id = 1938
// module chunks = 0